import css from './TabMenu.css'
import { fireEvent, show, hide } from '../../lib/jsfunc.js'
import { on, ready, query, queryAll } from '../../lib/dom.js'

ready(function(){
  
  // TabMenu Anchor - OnePager
  on('click', '.TabMenuA > div:first-child a', function(event){
    var a = event.target;
    if(event.target.tagName != "A"){
      var a = event.target.closest('a');
    }
    if(a.matches('.active')){
      event.preventDefault();
      return false;
    }
    var menu_item_name = a.getAttribute('data-name');
    var div = event.target.closest('div');
    var menu_items = queryAll(div,'a');
    
    for(var j=0;j<menu_items.length;++j){
      var elem = menu_items.item(j);
      if (menu_item_name != elem.getAttribute('data-name')) {
        elem.classList.remove('active');
      } else {
        elem.classList.add('active');
      }
    }
  })
  // TabMenu
  on('click', '.TabMenu > div:first-child a', function(event){
    event.preventDefault();
    var a = event.target;
    if(event.target.tagName != "A"){
      var a = event.target.closest('a');
    }
    var div = event.target.closest('div');
    var menu_item_name = a.getAttribute('data-name');
    var menu_items = queryAll(div,'a');
    
    for(var j=0;j<menu_items.length;++j){
      var elem = menu_items.item(j);
      if (menu_item_name != elem.getAttribute('data-name')) {
        elem.classList.remove('active');
      } else {
        elem.classList.add('active');
      }
    }
    var div = query(event.target.closest('.TabMenu'), ':scope>div:nth-child(2)');
    var content_items = queryAll(div, ':scope>div');
    for(var k=0;k<content_items.length;++k){
      var elem = content_items.item(k);
      if (menu_item_name != elem.getAttribute('data-name')) {
        hide(elem);
      } else {
        show(elem);
      }
    }
  })
  
//   [].forEach.call( queryAll('.TabMenu'), function(elem) {
//     var menu = query(elem, ':scope>div:first-child');
//     var content = query(elem, ':scope>div:nth-child(2)');
//     var content_items = queryAll(content, ':scope>div');
//     
//     var item_name = query(menu, 'a.active').getAttribute('data-name');
// 
//     window.history.replaceState({'tabmenuitem':item_name}, '', window.location);
//     var menu_items = queryAll(menu, 'a');
//     
//     on(menu, 'click', 'a', function(event){
//       event.preventDefault();
//       var a = event.target;
//       if(event.target.tagName != "A"){
//         var a = event.target.closest('a');
//       }
//       var menu_item_name = a.getAttribute('data-name');
//       var menu_item_href = a.getAttribute('href');
// 
//       for(var j=0;j<menu_items.length;++j){
//         var elem = menu_items.item(j);
//         if (menu_item_name != elem.getAttribute('data-name')) {
//           elem.classList.remove('active');
//         } else {
//           elem.classList.add('active');
//         }
//       }
// 
//       for(var k=0;k<content_items.length;++k){
//         var elem = content_items.item(k);
//         if (menu_item_name != elem.getAttribute('data-name')) {
//           hide(elem);
//         } else {
//           show(elem);
//         }
//       }
// 
//       // Replace <head> tags
//       var new_item_name = query(menu, 'a.active').getAttribute('data-name');
//       var new_item_href = query(menu, 'a[data-name="'+new_item_name+'"]').getAttribute('href');
// 
//       var title = query('.title-meta span.title-'+ new_item_name);
//       if(title){
//         var menu_item_title = title.textContent;
//         document.title = menu_item_title;
//       }
//       var meta = query('.title-meta span.meta-'+ new_item_name);
//       var metaDesc = query('meta[name=description]');
//       if(meta && metaDesc){
//         var menu_item_meta = meta.textContent;
//         query('meta[name=description]').setAttribute('content', menu_item_meta);
//       }
//       if(new_item_href){
//         window.history.pushState({'tabmenuitem':menu_item_name}, '', new_item_href);
//       }
//     })
//   });

  //Browser vor/zurück
  window.addEventListener('popstate', function (event){
    if( window.history.state){
      state = window.history.state;

      if( state.tabmenuitem ){
        active_item_name = state.tabmenuitem;
        var menu = query('.TabMenu > div:first-child');
        var content = query('.TabMenu > div:nth-child(2)');

        var old = query(menu, 'a.active').getAttribute('data-name');

        query(menu, 'a.active').classList.remove('active');
        query(menu, 'a[data-name="'+active_item_name+'"]').classList.add('active');
        hide(query(content, 'div[data-name="'+old+'"]'));
        show(query(content, 'div[data-name="'+active_item_name+'"]'));

        var titleSpan = query('.title-meta span.title-'+ active_item_name);
        if(titleSpan){
          document.title = titleSpan.textContent;
        }

        var metaSpan = query('.title-meta span.meta-'+ active_item_name);
        var metaDesc = query('meta[name=description]');
        if(metaSpan && metaDesc){
          metaDesc.setAttribute('content', metaSpan.textContent);
        }
      }
    }
  });


 
  // Click-Event triggern, damit bei Reload der Hash ausgewertet wird
  if(window.location.hash) {
    if(query('a[href="'+window.location.hash+'"]'))
      fireEvent(query('a[href="'+window.location.hash+'"]'), 'click');
  }

  // Bei Page-Up ersten Menüpunkt aktivieren und Hash löschen
  on('click', 'a.page-up[href="#"]', function(event){
    if(query('.TabMenuA')){
      var first = query('.TabMenuA>div:first-child>a:first-child');
      var active = query('.TabMenuA>div:first-child>a.active');
      active.classList.remove('active');
      first.classList.add('active');
      var href = window.location.href.split(/[?#]/)[0];
    }
  })
  /*
  window.addEventListener("hashchange", function(event){
    console.log(window.location.hash);
    var div = query('.GRID_COLUMNS');
    if (!div){
      return;
    }
    var hash = window.location.hash.split("#")[1];
    if(!hash) return false;
                          var viewportOffset = div.getBoundingClientRect();
    var JumpLabel = query('.TabMenuA>div:nth-child(2)>div[data-name="'+hash+'"]>.JumpLabel');
    console.log(document.documentElement.scrollHeight);
    console.log(window.innerHeight);
    console.log(window.pageYOffset);
    
    var header = query('.HEADER');
    var html = query('html');
    var offset = 250 + window.pageYOffset;
    JumpLabel.style.paddingTop = offset;
    JumpLabel.style.marginTop = -offset;
    JumpLabel.setAttribute('style', 'margin-top:-'+offset+'px;padding-top:'+offset+'px;');
    console.log(JumpLabel);
    console.log('Height Html ' + offset);
    
  });
*/
})
